module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Einstellungen.994614a2.jpg";